import { RootState } from '../reducers';

export const getStaticViewState =
  (state: RootState, view: StaticView): ViewDataSet => state.StaticViews[view];

export const getStaticViewCashe =
  (state: RootState, view: StaticView): WithCache => state.StaticViews[view].cache;

export const getStaticColumns =
  (state: RootState, view: StaticView): SingleColumn[] => state.StaticViews[view].columns;

export const getStaticViewIsWKD =
  (state: RootState, view: StaticView): boolean => state.StaticViews[view].isWKD;